import(/* webpackMode: "eager", webpackExports: ["SupportContent"] */ "/vercel/path0/src/components/support/SupportContent.tsx");
